// this is an autogenerated file from DesignSystem/GenerateLettersModal/Content/Letters/Letter/Actions/EditLetterAction/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_GenerateLettersModal_Content_Letters_Letter_Actions_EditLetterAction(
  $patient_id: uuid!
  $document_template_id: uuid!
  $recipient_id: uuid
  $postal_address_id: uuid
  $tooth_chart_snapshot_id: Int
  $tooth_marking_ids: [Int!]
) {
  tasks_generate_letter(
    document_template_id: $document_template_id
    patient_id: $patient_id
    recipient_id: $recipient_id
    postal_address_id: $postal_address_id
    tooth_chart_snapshot_id: $tooth_chart_snapshot_id
    tooth_marking_ids: $tooth_marking_ids
  ) {
    documentNodeId
  }
}

`